import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SyncOutline } from '@ant-design/icons-angular/icons';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';
import { MembersModule } from '@main-client/src/app/members/members.module';

import { EditHubSegmentationItemsDrawerService } from '@main-client/src/app/edit-hub-segmentation-items-drawer/edit-hub-segmentation-items-drawer.service';

import { EditHubSegmentationItemsDrawerComponent } from './edit-hub-segmentation-items-drawer.component';

@NgModule({
  declarations: [EditHubSegmentationItemsDrawerComponent],
  imports: [
    CommonModule,
    DragDropModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    MembersModule,
    NzDrawerModule,
    NzIconModule.forChild([SyncOutline]),
    NzSpinModule,
    NzTabsModule,
    NzTableModule,
    ReactiveFormsModule,
    TtcMatInputModule,
  ],
  providers: [EditHubSegmentationItemsDrawerService],
})
export class EditHubSegmentationItemsDrawerModule {}
